import { Tooltip, TooltipContent, TooltipTrigger } from "components/common/tooltips/Tooltip";
import React from "react";
import { FaCircleInfo } from "react-icons/fa6";

export const GridHeaderWithTooltip = ({
  headerText,
  tooltipText,
}: {
  headerText: string;
  tooltipText: any;
}) => {
  return (
    <div className="flex items-center gap-1.5">
      {headerText}{" "}
      <Tooltip>
        <TooltipTrigger>
          <FaCircleInfo className="text-sm" />
        </TooltipTrigger>
        <TooltipContent>{tooltipText}</TooltipContent>
      </Tooltip>
    </div>
  );
};
